import { Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
    selector: 'mutara-button-row',
    template: `<mat-card-actions [align]="props.align ?? 'end'"> 
             <ng-container #fieldComponent></ng-container>
             </mat-card-actions>
      `,
    styleUrls: ['./button-row.component.scss'],
    standalone: false
})
export class ButtonRowComponent extends FieldWrapper { }